module.exports = __webpack_public_path__ + "img/vklogo.ec62e12b.jpg";